Reflux = require('reflux')

actions = [
    "get"
    "create"
    "update"
    "delete"
    "search"
]

module.exports = Reflux.createActions(actions)



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/actions/EventActions.cjsx
 **/